<template>
  <div>
    <div class="radioGroup">
      <div class="row">
        <div class="col-lg-4">
          <div v-for="(type, key) in calculation_types" class="custom-control custom-radio custom-control-inline">
            <input type="radio" name="baggagePriceTypeSwitcher" class="custom-control-input"
                   :id="'baggagePriceTypeSwitcher' + key"
                   :value="parseInt(key)"
                   v-model="form.baggage_price_calculation_type"
            >
            <label class="custom-control-label" :for="'baggagePriceTypeSwitcher' + key">{{type}}</label>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group form-row">
            <label class="col-lg-6 col-form-label" for="free_baggage_allowance">{{ i18n('Free baggage allowance') }}</label>
            <div class="col-lg-4">
              <input type="text" name="free_baggage_allowance" id="free_baggage_allowance"
                     class="form-control"
                     v-model="form.free_baggage_allowance"
                     :disabled="form.baggage_price_calculation_type === 1"
              >
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group form-row" v-if="form.baggage_price_calculation_type === 1">
            <label class="col-sm-3 col-form-label fs-12 pt-12">Тариф:</label>
            <div class="col-sm-9">
              <select-picker :form="form"
                             :field="'baggage_service_id'"
                             :items="baggage_services"
                             :value="'id'"
                             :text="'name'"
                             :prompt="i18n('Choose a rate')">
              </select-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="offset-4 col-lg-4">
          <div class="form-group form-row">
            <label class="col-lg-6 col-form-label" for="max_baggage_allowance">{{ i18n('Max baggage allowance') }}</label>
            <div class="col-lg-4">
              <input type="text" name="max_baggage_allowance" id="max_baggage_allowance"
                     class="form-control"
                     v-model="form.max_baggage_allowance"
                     :disabled="form.baggage_price_calculation_type === 1"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="table-wrapper" v-if="routeDetails.length" style="height: auto">
      <div class="table-responsive">
        <table class="table inputPrice" v-if="baggageServiceExist">
          <thead>
          <tr>
            <th scope="col" nowrap=""></th>
            <th scope="col" v-for="(routeDetail, i) in routeDetails" v-if="i > 0" :class="{'bg-primary': y === i}">
              {{routeDetail.station ? routeDetail.station.name : null}}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(routeDetail, i) in routeDetails" v-if="i < routeDetails.length - 1">
            <td :class="{'bg-primary': x === i}">
              {{routeDetail.station ? routeDetail.station.name : null}}
            </td>
            <td v-for="(routeDetail, j) in routeDetails" v-if="j > 0"
                :class="{'bg-darker': x >= i && y === j || x === i && y >= j}">
              <input v-if="j > i" @focus="setFocusToIntersect(i, j)"
                     type="text" class="form-control"
                     v-model="prices[i][j]" @change="roundPrice(i, j)"
                     :disabled="form.baggage_price_calculation_type === 1">
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
    import SelectPicker from '../../../components/SelectPicker';

    export default {
        name: "SetBaggagePrices",
        components: {SelectPicker},
        props: {
            form: {
                type: Object,
                required: true
            },
            routeDetails: {
                type: Array,
                default: []
            },
            prices: {
                type: Array,
                default: []
            },
            baggage_services: {
                type: Array,
                default: []
            },
            isUpdate: {
                type: Boolean,
                required: true
            },
            baggageServiceExist: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                calculation_types: [],
                x: null,
                y: null,
            }
        },
        created() {
            // TODO render settings for
            this.getCalculationTypes();
        },
        methods: {
            setFocusToIntersect(i, j) {
                this.x = i;
                this.y = j;
            },
            getCalculationTypes() {
                this.$api.get('schedule-trips.calculation')
                    .then(res => {
                        this.calculation_types = res.data;
                    });
            },
            roundAllPrices() {
                for (let i = 0; i < this.routeDetails.length; i++) {
                    for (let j = i + 1; j < this.routeDetails.length; j++) {
                        this.roundPrice(i, j);
                    }
                }
            },
            roundPrice(i, j) {
                this.prices[i][j] = Math.ceil(this.prices[i][j] / 100) * 100;
                this.fillPreviousPrices(i, j);
                this.$forceUpdate();
            },
            fillPreviousPrices(i, j) {
                for (let k = 0; k < j; k++) {
                    if (this.prices[i][k] === 0) {
                        this.prices[i][k] = this.prices[i][j];
                    }
                }
            }
        },
        watch: {
            isUpdate: function (val) {
                if (val === true) {
                    // console.log(this.routeDetails);
                }
            },
            "form.baggage_service_id": function () {
                this.$emit('baggageServiceChanged');
                // this.roundAllPrices();
                this.$forceUpdate();
            },
            routeDetails: function () {
                if (this.baggageServiceExist) {
                    // this.roundAllPrices();
                }
            }
        }
    }
</script>

<style scoped>
  .bg-darker {
    background-color: #e4e8eb;
  }
</style>
